export default __webpack_public_path__ + "../staticImages/winefinder-sprite-match-with-05.png";